import { useRequest } from 'features/request/useRequest';
import type { ConstructionTypeData } from 'gql/graphql';

import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { bimWorkOrderConstructionTypesGql } from '../../BimWorkOrderOthersPrice/bimWorkOrderOthersQueries';

export const useBimWorkOrderConstructionTypes = () => {
    const { orderId } = useParams();

    const variables = useMemo(
        () => ({
            workOrderId: Number(orderId),
        }),
        [orderId],
    );

    const [bimWorkOrderConstructionTypes, bimWorkOrderConstructionTypesStatus] = useRequest({
        requestId: 'bimWorkOrderConstructionTypes',
        query: bimWorkOrderConstructionTypesGql,
        variables,
    });

    const bimWorkOrderConstructionTypesData = useMemo(
        () =>
            (bimWorkOrderConstructionTypes?.bimWorkOrderConstructionTypes?.data?.filter((ct) => !!ct) ||
                []) as ConstructionTypeData[],
        [bimWorkOrderConstructionTypes?.bimWorkOrderConstructionTypes?.data],
    );

    return {
        bimWorkOrderConstructionTypesData,
        bimWorkOrderConstructionTypesStatus,
    };
};
